export enum OtherPayTypes {
	MiscPay = 1,
	SubstitutePay = 2,
	LeavePayout = 3,
	AbsenceRefund = 4,
	DeductionRefund = 5,
	PriorPeriodAdjustment = 6,
	PriorYear = 7,
	SupplementalPay = 8,
}
